export function onlyNumbers(value: string): string {
  return value.replace(/[^0-9]/g, '');
}

export function removeSpecialCharacters(str: string): string {
  return str.replace(/[^\p{L}\p{N}\s]/gu, '');
}
